'use client'

import { type Locale, useLanguageStore } from '@/stores/language-store'
import { NextIntlClientProvider } from 'next-intl'
import { type ReactNode, useEffect, useState } from 'react'

// Import messages statically to avoid dynamic import issues
import enMessages from '../../messages/en.json'
import koMessages from '../../messages/ko.json'
import zhMessages from '../../messages/zh.json'

const messages: Record<Locale, typeof enMessages | typeof koMessages | typeof zhMessages> = {
	en: enMessages,
	ko: koMessages,
	zh: zhMessages,
}

interface I18nProviderProps {
	children: ReactNode
}

export function I18nProvider({ children }: I18nProviderProps) {
	const locale = useLanguageStore(state => state.locale)
	const [mounted, setMounted] = useState(false)

	// Handle hydration mismatch
	useEffect(() => {
		setMounted(true)
	}, [])

	// Use default locale during SSR to avoid hydration mismatch
	const currentLocale = mounted ? locale : 'en'
	const currentMessages = messages[currentLocale]

	return (
		<NextIntlClientProvider locale={currentLocale} messages={currentMessages} timeZone="UTC">
			{children}
		</NextIntlClientProvider>
	)
}
